import { Component, Input } from '@angular/core';

@Component({
  selector: 'status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent {

  @Input() status!: string;

  validaStatus(status:string):string{
    if(
      this.status.toLocaleLowerCase() == "ativo" || 
      this.status.toLocaleLowerCase()  == 'em analise' || 
      this.status.toLocaleLowerCase()  == 'em aprovação'){

      return "status-amarelo";
      
    }else if(
      this.status.toLocaleLowerCase() == "cancelado" || 
      this.status.toLocaleLowerCase() == "nao aprovado" || 
      this.status.toLocaleLowerCase() == "negado"){

      return "status-vermelho";

    }else if(
      this.status.toLocaleLowerCase() == "quitado (por operação casada)" || 
      this.status.toLocaleLowerCase() == "pago" || 
      this.status.toLocaleLowerCase() == "aprovado" || 
      this.status.toLocaleLowerCase()  == 'autorizado'|| 
      this.status.toLocaleLowerCase() == "aprovada"){

      return "status-verde";

    }
    return "#007A47";
  }

}
